import { useId } from 'react';
import './Input.css';

function Input({ label, error, className = '', ...props }) {
  const id = useId();
  return (
    <div className="admin-field">
      {label && <label htmlFor={id}>{label}</label>}
      <input id={id} className={`admin-input ${className}`.trim()} {...props} />
      {error && <span className="admin-field-error">{error}</span>}
    </div>
  );
}

export default Input;
